<template>
  <TakeHour></TakeHour>
</template>

<script>
// @ is an alias to /src
import TakeHour from "@/components/TakeHour.vue";
export default {
  name: "TakeHourView",
  components: { TakeHour }
};
</script>
